var _path, _g, _path2, _g2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareBlack = function SvgShareBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shareBlack_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 9,
    width: 16,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9.596h15v10.308h-15V9.596Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shareBlack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.174 19.904H7.826A3.33 3.33 0 0 1 4.5 16.577v-3.656a3.33 3.33 0 0 1 3.326-3.325h.7a.563.563 0 0 1 0 1.125h-.7a2.203 2.203 0 0 0-2.201 2.2v3.656c0 1.215.987 2.202 2.201 2.202h8.348a2.204 2.204 0 0 0 2.201-2.202v-3.663c0-1.21-.984-2.193-2.193-2.193h-.707a.563.563 0 0 1 0-1.125h.707a3.322 3.322 0 0 1 3.318 3.318v3.663a3.33 3.33 0 0 1-3.326 3.327Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "shareBlack_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 2,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.438 4.5h1.124v10.156h-1.124V4.5Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shareBlack_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.656a.563.563 0 0 1-.563-.563v-9.03a.563.563 0 0 1 1.126 0v9.03c0 .31-.253.563-.563.563Z",
    fill: "#767676"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.813 7.822a.562.562 0 0 1-.398-.96l2.186-2.196a.578.578 0 0 1 .797 0l2.187 2.196a.562.562 0 0 1-.797.794L12 5.86l-1.788 1.796a.557.557 0 0 1-.398.166Z",
    fill: "#767676"
  })));
};
export default SvgShareBlack;